import React, { useEffect } from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import Apps from '../components/Apps';
import Billing from '../components/Billing';
import Footer from '../components/Footer';

const HomePage: React.FC = () => {
  // 从其他页面点 /#apps、/#billing 进来时，页面渲染完再滚到对应的区块
  useEffect(() => {
    if (window.location.hash) document.querySelector(window.location.hash)?.scrollIntoView();
  }, []);

  return (
    <div className="App">
      <Header />
      <main>
        <Hero />
        <Apps />
        <Billing />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
